// /src/config.js
const config = {
    API_URL: 'https://plevortbeta.fryde.id.lv'
};

export default config;
